import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AssetGroupTreeMetaDataServiceConfig = {
  name: "AssetGroupTreeMetaData",
  annotations: []
} as ServiceConfig;